<template>
  <div>
    <back ref="back"></back>
    <div class="top-tab border-bottom" :class="{top: top}">
      <router-link tag="div" to="bought" class="tab" replace >
        <span>已购课程</span>
      </router-link>
      <router-link tag="div" to="limitfree" class="tab" replace >
        <span>限免课程</span>
      </router-link>
      <router-link tag="div" to="collection" class="tab" replace >
        <span>收藏课程</span>
      </router-link>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
    <!-- 底部导航 -->
    <tab></tab>
  </div>
</template>

<script type="text/ecmascript-6">
import Tab from '@/components/tab/tab'
import NavTab from '@/components/base/nav-tab/nav-tab'
import back from '@/components/base/ui/back.vue'
export default {
  components: {
    Tab,
    NavTab,
    back
  },
  data() {
    return {
      top: false
    }
  },
  mounted() {
    this.top = this.$refs.back.linkOk
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .top-tab
    &.top
      top: size(80)
    position fixed
    width 100%
    left 0
    top 0
    background #ffffff
    z-index 9
    display flex
    height size(106)
    align-items center
    text-align center
    font-size size(30)
    color #999999
    box-shadow 0 1px 6px 1px rgba(0,0,0,.06)
    >div
      flex 1
      position relative
    .router-link-exact-active, .router-link-active
      font-weight 700
      color #333333
      &:after
        content ' '
        display block
        position absolute
        bottom size(-20)
        left 50%
        width size(30)
        margin-left size(-15)
        height 3px
        background $color-theme
        border-radius 1.5px
  .content
    padding-top size(106)
</style>


// WEBPACK FOOTER //
// src/components/mycourse/index.vue